import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { RouteDirectionProvider } from "./utils/RouteDirectionContext";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <RouteDirectionProvider>
        <App />
      </RouteDirectionProvider>
    </Router>
  </React.StrictMode>
);
